import React, { useEffect } from "react";
import { Navigate } from "react-router-dom";
import { setAuthorization } from "../helpers/api_helper";
import { useDispatch } from "react-redux";
import { useProfile } from "../Hooks/UserHooks";
import { logoutUser } from "../store/slices/Auth/Login/thunk";
import { toast } from "react-toastify";

const AuthProtected = (props: any) => {
  const dispatch: any = useDispatch();
  const { userProfile, loading, token } = useProfile();

  useEffect(() => {
    if (userProfile && !loading && token) {
      setAuthorization(token);
    } else if (!userProfile && loading && !token) {
      dispatch(logoutUser());
    }
  }, [token, userProfile, loading, dispatch]);

  if (!userProfile || !token) {
    toast.error("Not Authorized", { autoClose: 2000 });
    return <Navigate to="/login" replace />;
  } else {
    return <>{props.children}</>;
  }
};

export default AuthProtected;
